export default function normalizeEmail(email: string): string {
  if (email) {
    return email.replace(/\s+/g, '').toLowerCase();
  }
  return '';
}
